"use client";

import { MasterclassVideoPlayer } from "./masterclass-video-player";
import type { VideoContextType } from "@/lib/analytics/types";

interface VSLPlayerProps {
  publitioMediaId: string;
  playerId?: string;
  videoAssetKey: string;
  videoContextId: number;
  videoContextName: string;
  videoContextType: Extract<
    VideoContextType,
    "masterclass_landing" | "platform_vsl" | "masterclass_offer_vsl"
  >;
  videoVariantKey?: string;
}

export function VSLPlayer({
  publitioMediaId,
  playerId = "11848",
  videoAssetKey,
  videoContextId,
  videoContextName,
  videoContextType,
  videoVariantKey = `publitio_${publitioMediaId}_v1`,
}: VSLPlayerProps) {
  return (
    <div className="vsl-forge-container group relative">
      {/* Industrial frame */}
      <div className="vsl-frame">
        {/* Corner brackets */}
        <div className="corner-bracket top-left" />
        <div className="corner-bracket top-right" />
        <div className="corner-bracket bottom-left" />
        <div className="corner-bracket bottom-right" />

        {/* Video container */}
        <div className="bg-forge-dark relative aspect-video overflow-hidden rounded-md">
          <MasterclassVideoPlayer
            access="public"
            className="rounded-md"
            playerId={playerId}
            publitioMediaId={publitioMediaId}
            videoAssetKey={videoAssetKey}
            videoContextId={videoContextId}
            videoContextName={videoContextName}
            videoContextType={videoContextType}
            videoVariantKey={videoVariantKey}
          />
        </div>
      </div>
    </div>
  );
}
